if (window.reactroot_webpackPublicPath) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    __webpack_public_path__ = window.reactroot_webpackPublicPath;
}
